import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { className as _$className } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<span class=cctv-panel-count>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class=cctv-loading>ZOOM IN TO VIEW CAMERAS`),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class=cctv-loading>SCANNING VIEWPORT...`),
  _tmpl$4 = /*#__PURE__*/_$template(`<div class=cctv-empty>NO CAMERAS IN VIEWPORT`),
  _tmpl$5 = /*#__PURE__*/_$template(`<div class="cctv-list-panel panel-section"><div class=cctv-panel-header><span class=cctv-panel-title>CCTV CAMERAS</span></div><div class=cctv-camera-list>`),
  _tmpl$6 = /*#__PURE__*/_$template(`<div class=cctv-roadway>`),
  _tmpl$7 = /*#__PURE__*/_$template(`<div><div class=cctv-thumb-container><img class=cctv-thumb loading=lazy><span></span></div><div class=cctv-info><div class=cctv-name></div><div class=cctv-coords>, `, true, false, false);
/**
 * WorldView - CCTV Camera List Panel
 * Displays a scrollable list of CCTV cameras visible in the current viewport.
 * Always visible in the left bar regardless of ground layer toggle state.
 */

import { createSignal, createMemo, onCleanup, For, Show } from "solid-js";
import { groundState, setCenterStageCamera } from "../../layers/ground/store";
import { useCCTVFetcher } from "../../layers/ground/useCCTVFetcher";
import { PROXY_ENDPOINTS } from "../../config";
const THUMBNAIL_REFRESH_MS = 30_000;
export function CCTVCameraListPanel() {
  useCCTVFetcher();
  const [thumbVersion, setThumbVersion] = createSignal(0);
  const refreshTimer = setInterval(() => setThumbVersion(v => v + 1), THUMBNAIL_REFRESH_MS);
  onCleanup(() => clearInterval(refreshTimer));

  // Sort selected camera to top of list
  const sortedCameras = createMemo(() => {
    const cams = groundState.cctvCameras;
    const selectedId = groundState.centerStageCameraId;
    if (!selectedId) return cams;
    return [...cams].sort((a, b) => a.id === selectedId ? -1 : b.id === selectedId ? 1 : 0);
  });
  const thumbnailUrl = id => `${PROXY_ENDPOINTS.cctvThumbnail(id)}?v=${thumbVersion()}`;

  // Determine display state for camera list
  const listState = createMemo(() => {
    if (groundState.cctvTooHigh) return "tooHigh";
    if (groundState.cctvLoading) return "loading";
    if (groundState.cctvCameras.length === 0) return "empty";
    return "ready";
  });
  const hasVideo = cam => cam.media.some(m => m.type === "hls" || m.type === "mp4ts");
  return (() => {
    var _el$ = _tmpl$5(),
      _el$2 = _el$.firstChild,
      _el$3 = _el$2.firstChild,
      _el$5 = _el$2.nextSibling;
    _$insert(_el$2, _$createComponent(Show, {
      get when() {
        return listState() === "ready";
      },
      get children() {
        var _el$4 = _tmpl$();
        _$insert(_el$4, () => groundState.cctvCameras.length);
        return _el$4;
      }
    }), null);
    _$insert(_el$5, _$createComponent(Show, {
      get when() {
        return listState() === "tooHigh";
      },
      get children() {
        return _tmpl$2();
      }
    }), null);
    _$insert(_el$5, _$createComponent(Show, {
      get when() {
        return listState() === "loading";
      },
      get children() {
        return _tmpl$3();
      }
    }), null);
    _$insert(_el$5, _$createComponent(Show, {
      get when() {
        return listState() === "empty";
      },
      get children() {
        return _tmpl$4();
      }
    }), null);
    _$insert(_el$5, _$createComponent(Show, {
      get when() {
        return listState() === "ready";
      },
      get children() {
        return _$createComponent(For, {
          get each() {
            return sortedCameras();
          },
          children: cam => (() => {
            var _el$9 = _tmpl$7(),
              _el$0 = _el$9.firstChild,
              _el$1 = _el$0.firstChild,
              _el$10 = _el$1.nextSibling,
              _el$11 = _el$0.nextSibling,
              _el$12 = _el$11.firstChild,
              _el$14 = _el$12.nextSibling,
              _el$15 = _el$14.firstChild;
            _el$9.$$click = () => setCenterStageCamera(cam.id);
            _$insert(_el$10, (() => {
              var _c$ = _$memo(() => !!hasVideo(cam));
              return () => _c$() ? cam.status === "live" ? "LIVE" : "OFFLINE" : "IMG";
            })());
            _$insert(_el$12, () => cam.name);
            _$insert(_el$11, _$createComponent(Show, {
              get when() {
                return cam.roadway;
              },
              get children() {
                var _el$13 = _tmpl$6();
                _$insert(_el$13, () => cam.roadway, null);
                _$insert(_el$13, (() => {
                  var _c$2 = _$memo(() => !!cam.direction);
                  return () => _c$2() ? ` · ${cam.direction}` : "";
                })(), null);
                return _el$13;
              }
            }), _el$14);
            _$insert(_el$14, () => cam.latitude.toFixed(4), _el$15);
            _$insert(_el$14, () => cam.longitude.toFixed(4), null);
            _$effect(_p$ => {
              var _v$ = `cctv-item ${groundState.centerStageCameraId === cam.id ? "projected" : ""}`,
                _v$2 = thumbnailUrl(cam.id),
                _v$3 = cam.name,
                _v$4 = `cctv-status ${hasVideo(cam) ? cam.status === "live" ? "live" : "offline" : "img"}`;
              _v$ !== _p$.e && _$className(_el$9, _p$.e = _v$);
              _v$2 !== _p$.t && _$setAttribute(_el$1, "src", _p$.t = _v$2);
              _v$3 !== _p$.a && _$setAttribute(_el$1, "alt", _p$.a = _v$3);
              _v$4 !== _p$.o && _$className(_el$10, _p$.o = _v$4);
              return _p$;
            }, {
              e: undefined,
              t: undefined,
              a: undefined,
              o: undefined
            });
            return _el$9;
          })()
        });
      }
    }), null);
    return _el$;
  })();
}
export default CCTVCameraListPanel;
_$delegateEvents(["click"]);